"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const EditorUnderlineIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7 7a1 1 0 112 0v4c0 1.884.93 3 3 3s3-1.116 3-3V7a1 1 0 012 0v4c0 2.916-1.737 5-5 5s-5-2.084-5-5V7zm0 10h10a1 1 0 010 2H7a1 1 0 010-2z" fill="currentColor"/></svg>`
}, props));

EditorUnderlineIcon.displayName = 'EditorUnderlineIcon';
var _default = EditorUnderlineIcon;
exports.default = _default;